import { useSearch, useRouter } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { XCircleIcon, ArrowLeftIcon } from '@heroicons/react/24/outline'

import { Button } from '@/components/new/ui'

export const ErrorPage = () => {
    const { code, message } = useSearch({
        from: '/error',
    })

    const router = useRouter()

    const { t } = useTranslation()

    return (
        <div className="m-8 flex min-h-full flex-col items-center">
            <div className="bg-error-50 text-error-700 dark:bg-error-800 w-full max-w-md rounded-lg shadow-lg">
                <div className="px-5 py-7">
                    <div className="flex items-center space-x-2">
                        <div className="shrink-0">
                            <XCircleIcon className="text-error-500 dark:text-error-200 h-8 w-8" aria-hidden="true" />
                        </div>
                        {/* @ts-expect-error we can have any error code here */}
                        <h3 className="text-2xl font-medium leading-6">{t(`errorCodes.${code}`)}</h3>
                    </div>
                    <div className="mt-4 text-base">
                        <p>{message}</p>
                    </div>
                    <div className="mt-6">
                        <Button variant="default" onClick={() => router.history.back()}>
                            <ArrowLeftIcon data-icon="inline-start" className="mr-1 h-5 w-5" />
                            {t('routes.errorPage.goBack')}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}
